var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    {
      attrs: { widget: _vm.widget },
      scopedSlots: _vm._u([
        {
          key: "headerContent",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "header-extra" },
                [
                  _c("ColumnToggle", {
                    attrs: {
                      "table-name": "accountUsers",
                      "user-settings": _vm.userSettings,
                      "settings-status": _vm.getUserSettingsStatus,
                      "column-settings": _vm.columnSettings
                    },
                    on: { onChange: _vm.updateUserVisibleColumns }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "m-r-10 btn btn-sm widget-header-button",
                      on: {
                        click: function($event) {
                          return _vm.exportUsersCSV()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("ACTION_EXPORT_CSV")) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-select", {
                    staticClass:
                      "m-r-10 btn-xl pull-right widget-header-dropdown",
                    attrs: {
                      options: _vm.options,
                      clearable: false,
                      searchable: false
                    },
                    model: {
                      value: _vm.filters.role.value,
                      callback: function($$v) {
                        _vm.$set(_vm.filters.role, "value", $$v)
                      },
                      expression: "filters.role.value"
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filters.name.value,
                        expression: "filters.name.value"
                      }
                    ],
                    staticClass:
                      "form-control input-md widget-header-input m-r-10",
                    attrs: {
                      type: "search",
                      placeholder: _vm.$t("PLACEHOLDER_USERS_SEARCH")
                    },
                    domProps: { value: _vm.filters.name.value },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.filters.name, "value", $event.target.value)
                      }
                    }
                  })
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { staticClass: "m-b-15" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-success btn-sm",
                attrs: { type: "button", disabled: _vm.showAddNewForm },
                on: { click: _vm.displayNewForm }
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "ACTION_INVITE",
                      expression: "'ACTION_INVITE'"
                    }
                  ]
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid_table_holder" },
        [
          _c(
            "v-table",
            {
              staticClass: "table_beauty",
              attrs: {
                data: _vm.usersAndInvites,
                "current-page": _vm.currentPage,
                "page-size": 20,
                filters: _vm.filters,
                "hide-sort-icons": true
              },
              on: {
                "update:currentPage": function($event) {
                  _vm.currentPage = $event
                },
                "update:current-page": function($event) {
                  _vm.currentPage = $event
                },
                totalPagesChanged: function($event) {
                  _vm.totalPages = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function({ displayData }) {
                    return _c(
                      "tbody",
                      {},
                      [
                        _vm.showAddNewForm
                          ? _c(
                              "tr",
                              {
                                staticClass:
                                  "row-inline-new-form slide-down bg-row-even"
                              },
                              [
                                _c(
                                  "td",
                                  { attrs: { colspan: "100" } },
                                  [
                                    _c("InviteUserForm", {
                                      attrs: {
                                        "show-loader":
                                          _vm.inviteUserStatus.status ===
                                          "pending"
                                      },
                                      on: {
                                        cancel: _vm.hideNewForm,
                                        submit: _vm.onInviteUser
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(displayData, function(row, index) {
                          return [
                            !(_vm.isMobile && _vm.activeActionId == row.id)
                              ? _c(
                                  "tr",
                                  {
                                    key: row.id,
                                    class: {
                                      "bg-row-odd": index % 2 === 0,
                                      "bg-row-even": index % 2 !== 0
                                    }
                                  },
                                  [
                                    _vm.isMobile
                                      ? _c("td", [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-list-function btn-expand-actions",
                                              attrs: {
                                                disabled: _vm.showAddNewForm
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.displayMobileAction(
                                                    row.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-ellipsis-v"
                                              })
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.userVisibleColumns.includes("name")
                                      ? _c(
                                          "td",
                                          {
                                            class: {
                                              clickable: !_vm.showAddNewForm
                                            },
                                            on: {
                                              click: function($event) {
                                                !_vm.showAddNewForm
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(row.name) +
                                                "\n            "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.userVisibleColumns.includes("email")
                                      ? _c("td", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(row.email) +
                                              "\n            "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.userVisibleColumns.includes("role")
                                      ? _c("td", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(row.roleDisplay) +
                                              "\n            "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.userVisibleColumns.includes("invite")
                                      ? _c("td", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(row.inviteStatus) +
                                              "\n            "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.userVisibleColumns.includes(
                                      "canExportReport"
                                    )
                                      ? _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [
                                            row.canExportReport === false
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa fa-times text-danger"
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            row.canExportReport === true
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa fa-check text-success"
                                                })
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.isMobile
                                      ? _c(
                                          "td",
                                          [
                                            _c("UsersActions", {
                                              attrs: {
                                                user: row,
                                                disabled: _vm.showAddNewForm
                                              },
                                              on: {
                                                "delete-user": _vm.onDeleteUser,
                                                "delete-invite":
                                                  _vm.onDeleteInvite,
                                                "copied-invitation-url":
                                                  _vm.onCopiedInvitarionUrl
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isMobile && _vm.activeActionId == row.id
                              ? _c(
                                  "tr",
                                  {
                                    key: row.id + "-mobile",
                                    staticClass:
                                      "mobile-actions ng-animate-disabled slide-right"
                                  },
                                  [
                                    _c(
                                      "td",
                                      { attrs: { colspan: "10" } },
                                      [
                                        _c("UsersActions", {
                                          attrs: {
                                            user: row,
                                            disabled: _vm.showAddNewForm
                                          },
                                          on: {
                                            "collapse-actions": function(
                                              $event
                                            ) {
                                              !_vm.showAddNewForm &&
                                                _vm.hideMobileAction()
                                            },
                                            "delete-user": _vm.onDeleteUser,
                                            "delete-invite": _vm.onDeleteInvite,
                                            "copied-invitation-url":
                                              _vm.onCopiedInvitarionUrl
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        })
                      ],
                      2
                    )
                  }
                }
              ])
            },
            [
              _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
                _c(
                  "tr",
                  [
                    _vm.isMobile ? _c("th") : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.userVisibleColumns, function(col) {
                      return _c("v-th", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: _vm.columnSettings[col].displayName,
                            expression: "columnSettings[col].displayName"
                          }
                        ],
                        key: col,
                        class: _vm.columnSettings[col].class,
                        attrs: {
                          "default-sort": _vm.columnSettings[col].defaultSort,
                          "sort-key": _vm.columnSettings[col].name
                        }
                      })
                    }),
                    _vm._v(" "),
                    !_vm.isMobile
                      ? _c("th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "TABLE_COL_ACTIONS",
                              expression: "'TABLE_COL_ACTIONS'"
                            }
                          ]
                        })
                      : _vm._e()
                  ],
                  2
                )
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pagination-min" }, [
        _c(
          "div",
          { staticClass: "text-center p-7" },
          [
            _c("smart-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "total-pages": _vm.totalPages,
                "max-page-links": 20
              },
              on: {
                "update:currentPage": function($event) {
                  _vm.currentPage = $event
                },
                "update:current-page": function($event) {
                  _vm.currentPage = $event
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center empty-records" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "USERS_TABLE_LOADING",
                    expression: "'USERS_TABLE_LOADING'"
                  }
                ]
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.emptyUsers
        ? _c("div", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "USERS_TABLE_EMPTY",
                expression: "'USERS_TABLE_EMPTY'"
              }
            ],
            staticClass: "well well-sm text-center"
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }